<template>
    <div>
        <v-text-field
            v-model="form.name"
            label="类型名称*"
            :rules="[
                v => !!v || '类型名称不能为空'
                , v => checkNameRule(v) || '名称不合法，请使用数字、_、英文大小写字母命名，不能以数字开头且名称内容不能包含特殊字符'
                , v => checkRepeatName(v) || '类型名称已存在'
            ]"
        ></v-text-field>
        <!-- :rules="[v => !!v || '模型编号不能为空']" -->
        <v-text-field v-model="form.model_number" label="模型编号*" ></v-text-field>
        <v-text-field
            v-model="form.model_name"
            :rules="[v => checkNameRule(v) || '名称不合法，请使用数字、_、英文大小写字母命名，不能以数字开头且名称内容不能包含特殊字符']"
            label="模型名称"
        ></v-text-field>
        <v-switch v-model="form.is_public" label="公开"></v-switch>
        <v-text-field v-model="form.symbol" label="符号"></v-text-field>
        <v-text-field v-model="form.specifications" label="规格型号"></v-text-field>
        <v-text-field v-model="form.manufacturer" label="生成厂商"></v-text-field>
        <v-text-field v-model="form.structure_desc" label="结构说明"></v-text-field>
        <v-text-field v-model="form.principle_desc" label="原理说明"></v-text-field>
        <v-text-field v-model="form.function_desc" label="功能说明"></v-text-field>
    </div>
</template>
<script>
import { upload } from '@/api/user';
import { mapGetters, mapState } from 'vuex';
import { checkNameRule } from "@/utils/util"
export default {
    name: 'BaseTab',
    computed: {
        ...mapGetters(['showType']),
        ...mapState({
            typeForm: (state) => state.editorType.typeForm
        }),
        typeListDataMap() {
            const typeList = this.$store.state.editorType.typeList ?? [];
            const map = typeList.reduce((pre,next) => {
                pre[next.model_name] = next;
                return pre;
            }, {})
            return map;
        }
    },
    data() {
        return {
            form: {},
            metaForm: {},
        }
    },
    watch: {
        form: {
            deep: true,
            handler: function (val) {
                this.$store.dispatch('editorType/setTypeInfo', val)
            }
        }
    },
    mounted() {
        this.form = Object.assign({}, this.typeForm);
        this.metaForm = Object.assign({}, this.typeForm);
    },
    methods: {
        checkNameRule,
        checkRepeatName(val) {
            if (this.form._id) {
                const info = this.typeListDataMap[this.metaForm.model_name];
                return info.model_name === val 
                        || this.typeListDataMap[val] === undefined;
            }
            return this.typeListDataMap[val] === undefined;
        },
        upload(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();

            reader.onload = (e) => {
                // this.user.avatar = e.target.result;
            };
            reader.readAsDataURL(file);
            let type = file.type.split('/') && file.type.split('/')[1] ? file.type.split('/')[1] : '';
            if (!['jpeg', 'jpg', 'png'].includes(type)) {
                this.$message.warning('请选择正确的图片格式');
                return;
            }
            let formData = new FormData();
            formData.append('modelImage', file);
            upload(formData).then((res) => {
                if (res.code === '200') {
                    this.form.icon = res.data.url;
                    this.$forceUpdate()
                }
            })
        },
        getImage() {
            // const _this = this
            // Swal.fire({
            //     title: '生成图标',
            //     text: `根据当前截图生成图标`,
            //     type: 'warning',
            //     showCancelButton: true,
            //     confirmButtonClass: 'md-button md-success btn-fill',
            //     cancelButtonClass: 'md-button md-danger btn-fill',
            //     confirmButtonText: '确 定',
            //     cancelButtonText: '取 消',
            //     buttonsStyling: false
            // }).then((result) => {
            //     if (result.value) {
            //         let base64 = _this.topNode.$refs.ThreeModel.getImage()
            //         _this.form.icon = base64
            //         _this.$forceUpdate()
            //     }
            // })
            // this.$nextTick(() => {
            //     document.getElementById('mainCardContent').appendChild(document.querySelector('.swal2-container'))
            // })
        },
        base64toFile(dataurl, filename = 'file') {
            let arr = dataurl.split(',')

            let mime = arr[0].match(/:(.*?);/)[1]

            let suffix = mime.split('/')[1]

            let bstr = Buffer.from(arr[1], 'base64')

            let n = bstr.length

            let u8arr = new Uint8Array(n)

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], `${filename}.${suffix}`, {
                type: mime
            })
        }
    }
};
</script>
<style>
.pictureImg input[type=file] {
    cursor: pointer;
    display: block;
    height: 100%;
    left: 0;
    opacity: 0 !important;
    position: absolute;
    top: 0;
    width: 100%;
}
</style>